import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';
import { isSurveyFinished } from '../../../../api/Surveys';

import {
  Wrapper,
  PreTitle,
  Title,
  Text
} from '../../components/ui';

import SkillsProgress from '../../components/skills-progress';

class ManagingConflict extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      progressValue: 0
    };
  }

  componentDidMount() {
    const { surveys } = this.props;
    const receiverId = Auth.getUserId();
    const finishedSurveys =
      surveys && surveys.length > 0
        ? surveys.filter(i => isSurveyFinished(i))
        : [];
    const lastSurveyId =
      finishedSurveys.length > 0
        ? finishedSurveys[finishedSurveys.length - 1].id
        : 0;

    if (!lastSurveyId) {
      return this.setState({
        loaded: true
      });
    }

    getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/score/${receiverId}/${lastSurveyId}/`
    ).then(res => {
      const surveyScore = res.body;
      const userScoreQuestions = surveyScore.user_score_question || [];

      const neededQuestion = userScoreQuestions.find(i => i.question === 'Managing Conflict');
      const progressValue = neededQuestion ? neededQuestion.median : 0;

      this.setState({
        loaded: true,
        progressValue
      });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      progressValue
    } = this.state;

    return loaded ? (
      <Wrapper>
        <PreTitle>Feedback</PreTitle>
        <Title>Having Knowledge, Skills, and Abilities</Title>
        <SkillsProgress
          title="Having Knowledge, Skills, and Abilities"
          progressValue={progressValue}
        />
        <Text>
          <p>Having the knowledge, skills, and abilities are great characteristics to possess on any task/group project.</p>
          <p>If you’re acquiring knowledge or skills to improve team’s performance and/or demonstrating the knowledge, skills, and abilities to do excellent team work, you are demonstrating high levels of these highly desirable skills.<br /><br /></p>
          <p>On the flip side, if you are unable or unwilling to develop knowledge or skills to contribute to the team, then you’re demonstrating low levels of knowledge, skills, and abilities.</p>
        </Text>
      </Wrapper>
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default ManagingConflict;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/feedback/managing-conflict.js